<button mat-icon-button (click)="toggleSideNav()">
  <mat-icon>menu</mat-icon>
</button>

<style>
  .mat-button, .mat-icon-button {
  background-color: #2dce98;
  color: #fff;
  font-weight: bold;
}
</style>
